import RequestCache from "./RequestCache";
//import RequestAbstract from "./RequestAbstract";

export default class Doctors extends RequestCache {
    get cacheInterval() {
        return 7;
    }

    get link() {
        return this.links.doctors;
    }

    async getAll() {
        return await this.getAllFiltered([], this.getSortField(["lname", "fname", "sname"]));
    }
}
